import { createReducer } from 'redux-starter-kit';
import {
  fetchUserGroup, updateUserGroupRequest, fetchCompanyPageData,
} from './companyUiActions';
import { selectRequest } from '../../../domain/requests/RequestReducer';


/**
 * A selector for the load page data request.
 * @param {object} state The redux state of the application.
 */
export const selectCompanyPageDataRequest = (state) => {
  const requestId = state.via.ui.company.fetchCompanyDataRequestId;
  if (!requestId) return null;

  return selectRequest(state, requestId);
};

/**
 * A Selector for the laod user group request
 */
export const selectFetchUserGroupRequest = (state) => {
  const requestId = state.via.ui.company.fetchUserGroupRequestId;
  if (!requestId) return null;

  return selectRequest(state, requestId);
};

/**
 * A selector for the update user group request
 */
export const selectUpdateGroupRequest = (state) => {
  const requestId = state.via.ui.company.updateGroupRequestId;
  if (!requestId) return null;

  return selectRequest(state, requestId);
};

const initialCompanyState = {
  fetchCompanyDataRequestId: null,
  fetchUserGroupRequestId: null,
  updateGroupRequestId: null,
};

/**
 * A reducer for the company actions
 */
const companyUiReducer = createReducer(initialCompanyState, {
  [fetchCompanyPageData]: (state, action) => ({
    ...state,
    fetchCompanyPageDataRequestId: action.payload,
  }),

  [fetchUserGroup]: (state, action) => ({
    ...state,
    fetchUserGroupRequestId: action.payload,
  }),

  [updateUserGroupRequest]: (state, action) => ({
    ...state,
    updateGroupRequestId: action.payload,
  }),
});


export default companyUiReducer;
